import { useEtablissementStore } from "../../stores/etablissement/etablissement.store";
import { formatPhoneNumber } from "../../utils";
import InformationSection from "../InformationSection/InformationSection";

import styles from "./ContactSection.module.scss";

export default function ContactSection() {
  const { selectedEtablissement } = useEtablissementStore();
  return (
    <article className={styles.contactSection}>
      <header className={styles.contactSection__header}>
        <h2>Kontakt</h2>
      </header>
      <main className={styles.contactSection__main}>
        <section className={styles.contactSection__main__infosRef}>
          <header className={styles.contactSection__main__infosRef__header}>
            <h3>„Schau in meine Welt“-Ansprechpartner</h3>
          </header>
          <main className={styles.contactSection__main__infosRef__main}>
            <div>
              <InformationSection
                label="NAME des Ansprechpartners"
                text={
                  selectedEtablissement?.information_referent?.nom_referent ||
                  "-"
                }
              />
              <InformationSection
                label="E-Mail"
                text={
                  selectedEtablissement?.information_referent?.email_referent ||
                  "-"
                }
              />
            </div>
            <div>
              <InformationSection
                label="Vorname des Ansprechpartners"
                text={
                  selectedEtablissement?.information_referent
                    ?.prenom_referent || "-"
                }
              />
              <InformationSection
                label="Telefon"
                text={formatPhoneNumber(
                  selectedEtablissement?.information_referent?.phone_referent
                )}
              />
            </div>
          </main>
        </section>

      </main>
    </article>
  );
}
